import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const authenticateUser = (username, password) =>
  axios.post(`${apiUrl}api/authenticate`, {
    username,
    password
  });

export const requestNewToken = (token, refreshToken) =>
  axios.post(`${apiUrl}api/refresh`, {
    token,
    refreshToken
  });



// WEBPACK FOOTER //
// ./src/actions/auth/requests.js